import {measurementStartLabel} from "../../../measurements-component/measurement-interval";
import {Component, Input, OnChanges} from '@angular/core';
import {ConnectionType, DataType, MeasurementsResult} from "@flowmaps-com/flowmaps-typescriptmodels";
import {View} from "../../../../common/view";
import {Handler} from "../../../../common/handler";
import {DashboardTime} from "../../../../utils/chart-data-provider";
import {SourceInfo} from "../../../../utils/source-providers/sources-provider";
import {DashboardContext} from "../../../dashboard/dashboard.context";

@Component({
    selector: 'app-quarterly-report-insights',
    templateUrl: './quarterly-report-insights.component.html'
})
@Handler()
export class QuarterlyReportInsightsComponent extends View implements OnChanges {
    @Input() selectedLocation: SourceInfo;
    @Input() timeRange: DashboardTime;

    contractedPowerIncidentGroups = [];

    ngOnChanges() {
        this.loadContractedPowerIncidents();
    }

    private loadContractedPowerIncidents() {
        const connections = (this.selectedLocation?.source?.location?.connections || [])
            .filter(connection => connection.info?.connectionType === ConnectionType.Electricity);
        const connectionIds = connections.map(connection => connection.connectionId).filter(Boolean);
        if (connectionIds.length === 0 || !this.timeRange?.start || !this.timeRange?.end) {
            this.contractedPowerIncidentGroups = [];
            return;
        }
        this.sendQuery("com.flowmaps.api.measurements.GetContractedPowerIncidents", {
            connectionIds,
            timeRange: {
                start: this.timeRange.start,
                end: this.timeRange.end
            }
        }).subscribe((results: MeasurementsResult[]) => {
            this.contractedPowerIncidentGroups = this.mapContractedPowerIncidentGroups(results || [], connections);
        });
    }

    private mapContractedPowerIncidentGroups(results: MeasurementsResult[], connections: any[]) {
        return results.map(result => {
            const connection = connections.find(connection => connection.connectionId === result.entityId);
            return {
                connectionCode: connection.info?.code || connection.connectionId,
                consumptionRows: this.topRows(result, connection, DataType.electricityPower, 10),
                feedInRows: this.topRows(result, connection, DataType.electricityFeedInPower, 5)
            };
        }).filter(group => group?.consumptionRows.length || group?.feedInRows.length);
    }

    private topRows(result: MeasurementsResult, connection: any, dataType: DataType, limit: number): ContractedPowerIncident[] {
        const threshold = dataType === DataType.electricityFeedInPower
            ? connection.info?.contractedFeedInCapacity
            : connection.contractedCapacity;
        return (result.measurements?.[dataType] || [])
            .map(point => ({
                startLabel: measurementStartLabel(point, "DD-MM-YYYY HH:mm"),
                measuredValue: point.value,
                exceedance: point.value - threshold,
                unit: DashboardContext.getMeasurementUnit(dataType)
            }))
            .sort((a, b) => b.exceedance - a.exceedance)
            .slice(0, limit);
    }
}

interface ContractedPowerIncident {
    startLabel: string;
    measuredValue: number;
    exceedance: number;
    unit: string;
}
